// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UploadButton-cls1___b9541eb7771b7a12ced{/*!*/}.UploadButton-cls2___df7336c03b93ac34326{position:relative;top:0;left:-12px;margin-right:-12px;width:6px;height:6px;border-radius:50%;background:#bb0202;align-self:flex-start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "UploadButton-cls1___b9541eb7771b7a12ced",
	"cls2": "UploadButton-cls2___df7336c03b93ac34326 UploadButton-cls1___b9541eb7771b7a12ced"
};
export default ___CSS_LOADER_EXPORT___;
